<template>
  <div v-rect-loading="loading" class="candidate-offer-list">
    <div class="head">
      <span class="label">{{ $t(`${i18nPrefix}.title.myOffer`) }}</span>
    </div>
    <TableList
      class="offer-letter-record-list"
      row-key="id"
      noHead
      hideOnClick
      :showCreateBtn="false"
      :listData="offerRecordList"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
    >
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import moment from 'moment'
import { addI18nProperty, getConstantI18nValue } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { OFFER_LETTER_INVITE_STATUS } from '@/constant/company'
import { AsyncTask } from '@/utils/common'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'personal.offerLetter',
      loading: false,
      offerRecordList: [],
      actionBtn: {
        download: {
          labelI18nKey: 'common.btn.download',
          onclick: this.handleExportPDF
        },
        viewDetail: {
          labelI18nKey: 'personal.offerLetter.btn.viewDetail',
          show: true,
          onclick: this.handleOperate
        }
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.company.offerLetterInviteRecordManagement.label.inviteOfferLetterDate'),
          dataKey: 'created_time',
          formatter: (val) => {
            return moment(val).format('YYYY/MM/DD')
          }
        },
        {
          label: this.$t('admin.company.offerLetterInviteRecordManagement.label.inviteCompany'),
          dataKey: 'companyI18nName'
        },
        {
          label: this.$t('admin.company.offerLetterInviteRecordManagement.label.inviteJobName'),
          dataKey: 'jobI18nName'
        },
        {
          label: this.$t('admin.company.offerLetterInviteRecordManagement.label.inviteOfferLetterStatus'),
          dataKey: 'status',
          formatter: (val) => {
            return getConstantI18nValue(OFFER_LETTER_INVITE_STATUS, val, `${this.i18nPrefix}.INVITE_STATUS`)
          }
        }
      ]
      return columns
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('personal', ['getPersonalAllOfferLetter']),
    ...mapActions('application', [
      'createExportCandidateOfferLetterInfoTask',
      'getExportCandidateOfferLetterTaskStatus'
    ]),
    initPage () {
      this.loadOfferLetterList()
    },
    async loadOfferLetterList () {
      this.loading = true
      try {
        const resp = await this.getPersonalAllOfferLetter({ company_id: this.companyId })
        if (resp) {
          _.forEach(resp, item => {
            addI18nProperty(item, 'companyI18nName', 'job.company.cn_name', 'job.company.name')
            addI18nProperty(item, 'jobI18nName', 'job.cn_title', 'job.title')
          })
          this.offerRecordList = resp
        }
      } finally {
        this.loading = false
      }
    },
    handleExportPDF (row) {
      this.loading = true
      const exportOfferLetterPdfStatus = {
        finished: false,
        task: null
      }
      exportOfferLetterPdfStatus.finished = false
      exportOfferLetterPdfStatus.task = new AsyncTask(() => this.createExportCandidateOfferLetterInfoTask({
        candidate_id: row.candidate.id,
        job_id: row.job.id
      }), (taskId) => this.getExportCandidateOfferLetterTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/offer-letter/?task_id=${taskId}&download=1`)
        exportOfferLetterPdfStatus.finished = false
        exportOfferLetterPdfStatus.task = null
        this.loading = false
      })
    },
    handleToOperateOffer (row) {
      this.$router.replace({
        path: '/recruiting/personal/offer-letter/edit',
        query: {
          job_id: row.job.id,
          candidate_id: row.candidate.id,
          invite_id: row.id,
          company_id: row.job.company.id
        }
      })
    },
    handleOperate (row) {
      if (row.status === OFFER_LETTER_INVITE_STATUS.INVITED) {
        this.handleToOperateOffer(row)
      } else {
        this.handleViewOfferDetail(row)
      }
    },
    handleViewOfferDetail (row) {
      this.$router.push({ path: `/recruiting/personal/offer-letter/${row.id}/detail`, query: { company_id: row.job.company.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-offer-list {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .offer-letter-record-list {
    padding: 24px 32px 0;
  }
}
</style>
